import moment from "moment"

const _3hours = 3 * 3600 * 1000

export const formatToLkDateTime = (datetime: string) => {
  const shited = new Date(datetime ? +moment(datetime).toDate() + _3hours : datetime).toISOString()
  return shited.replace(/\.\d{3}Z/, 'Z')
}
